import React            from 'react';
import Card             from "@mui/material/Card";
import CardContent      from "@mui/material/CardContent";
import Typography       from "@mui/material/Typography";
import {useTranslation} from "react-i18next";
import Price            from "../../common/data/Price/Price";
import makeStyles from '@mui/styles/makeStyles';
import CardHeader       from "@mui/material/CardHeader";
import IconButton       from "@mui/material/IconButton";
import DeleteIcon       from "@mui/icons-material/Delete";
import Grid             from '@mui/material/Grid';
import EditIcon         from '@mui/icons-material/Edit';

const useStyles = makeStyles({
    description: {
        whiteSpace: 'pre-wrap'
    },
    fillHeight: {height: '100%'}
});

const Plan = ({plan, onDelete, onEdit, vat, viewOnly = false}) => {
    const {t} = useTranslation();
    const classes = useStyles();
    return (
        <Card className={classes.fillHeight} variant='outlined'>
            <CardHeader
                action={
                    (!viewOnly) ? (
                    	<Grid container spacing={3} justifyContent='space-between'>
		                    {onEdit && <Grid item>
			                    <IconButton color='primary' onClick={onEdit} size="large">
				                    <EditIcon/>
			                    </IconButton>
		                    </Grid>}
		                    {onDelete && <Grid item>
			                    <IconButton color='secondary' onClick={onDelete} size="large">
				                    <DeleteIcon/>
			                    </IconButton>
		                    </Grid>
		                    }
	                    </Grid>
	                    )
	                    : undefined
                }
                title={plan.name}

            />
            <CardContent>
                <Typography variant={"h6"}>
                    {t('price_lbl')}
                </Typography>
                {plan.free === 'N' && <Typography color="textSecondary" variant='body2' gutterBottom>
                    <Price
                        priceIncludeVat={plan.vatIncluded ?? false}
                        value={parseFloat(plan.price)}
                        currency={plan.currency}
                        vat={parseFloat(vat)}
                    />
                </Typography>}
                {plan.free === 'Y' && <Typography color="textSecondary" variant='body2' gutterBottom>
                    {t('plan_free_notice')}
                </Typography>}
                <Typography variant="body2" color="textSecondary" gutterBottom component="p"
                            className={classes.description}>
                    {plan.description}
                </Typography>
            </CardContent>
        </Card>
    );
};

export default Plan;
